import React from "react";
import { TYPE_PC, TYPE_SP } from "../../common/defines";
import { TopGallery } from "./TopGallery";

export class TopPanel extends React.Component {
  render() {
    return (
      <div className="top_panel">
        <div className="panel">
          <TopGallery {...this.props} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/top/TopPanel.jsx